module.exports = __webpack_public_path__ + "static/media/dungeon_floor_ns.1aee2b0f.png";